import React from 'react';
import AccessContainer from './AccessContainer';

const AccessView = () => {
    return (
        <div>
            <AccessContainer/>
        </div>);
}

export default AccessView